export const countries = [
  { code: '', label: '', phone: '' },
  { code: 'AD', label: 'ANDORRA', phone: '376' },
  {
    code: 'AE',
    label: 'EMIRATOS ÁRABES UNIDOS',
    phone: '971',
  },
  { code: 'AF', label: 'AFGANISTÁN', phone: '93' },
  {
    code: 'AG',
    label: 'ANTIGUA Y BARBUDA',
    phone: '1-268',
  },
  { code: 'AI', label: 'ANGUILA', phone: '1-264' },
  { code: 'AL', label: 'ALBANIA', phone: '355' },
  { code: 'AM', label: 'ARMENIA', phone: '374' },
  { code: 'AO', label: 'ANGOLA', phone: '244' },
  { code: 'AQ', label: 'ANTÁRTIDA', phone: '672' },
  { code: 'AR', label: 'ARGENTINA', phone: '54' },
  { code: 'AS', label: 'SAMOA AMERICANA', phone: '1-684' },
  { code: 'AT', label: 'AUSTRIA', phone: '43' },
  {
    code: 'AU',
    label: 'AUSTRALIA',
    phone: '61',
    suggested: true,
  },
  { code: 'AW', label: 'ARUBA', phone: '297' },
  { code: 'AX', label: 'ISLAS ÅLAND', phone: '358' },
  { code: 'AZ', label: 'AZERBAIYÁN', phone: '994' },
  {
    code: 'BA',
    label: 'BOSNIA Y HERZEGOVINA',
    phone: '387',
  },
  { code: 'BB', label: 'BARBADOS', phone: '1-246' },
  { code: 'BD', label: 'BANGLADÉS', phone: '880' },
  { code: 'BE', label: 'BÉLGICA', phone: '32' },
  { code: 'BF', label: 'BURKINA FASO', phone: '226' },
  { code: 'BG', label: 'BULGARIA', phone: '359' },
  { code: 'BH', label: 'BARÉIN', phone: '973' },
  { code: 'BI', label: 'BURUNDI', phone: '257' },
  { code: 'BJ', label: 'BENÍN', phone: '229' },
  { code: 'BL', label: 'SAN BARTOLOMÉ', phone: '590' },
  { code: 'BM', label: 'BERMUDAS', phone: '1-441' },
  { code: 'BN', label: 'BRUNÉI DARUSSALAM', phone: '673' },
  { code: 'BO', label: 'BOLIVIA', phone: '591' },
  { code: 'BR', label: 'BRASIL', phone: '55' },
  { code: 'BS', label: 'BAHAMAS', phone: '1-242' },
  { code: 'BT', label: 'BUTÁN', phone: '975' },
  { code: 'BV', label: 'ISLA BOUVET', phone: '47' },
  { code: 'BW', label: 'BOTSUANA', phone: '267' },
  { code: 'BY', label: 'BIELORRUSIA', phone: '375' },
  { code: 'BZ', label: 'BELICE', phone: '501' },
  {
    code: 'CA',
    label: 'CANADÁ',
    phone: '1',
    suggested: true,
  },
  {
    code: 'CC',
    label: 'ISLAS COCOS (KEELING)',
    phone: '61',
  },
  {
    code: 'CD',
    label: 'CONGO, REPÚBLICA DEMOCRÁTICA DEL',
    phone: '243',
  },
  {
    code: 'CF',
    label: 'REPÚBLICA CENTROAFRICANA',
    phone: '236',
  },
  {
    code: 'CG',
    label: 'CONGO, REPÚBLICA DEL',
    phone: '242',
  },
  { code: 'CH', label: 'SUIZA', phone: '41' },
  { code: 'CI', label: 'COSTA DE MARFIL', phone: '225' },
  { code: 'CK', label: 'ISLAS COOK', phone: '682' },
  { code: 'CL', label: 'CHILE', phone: '56' },
  { code: 'CM', label: 'CAMERÚN', phone: '237' },
  { code: 'CN', label: 'CHINA', phone: '86' },
  { code: 'CO', label: 'COLOMBIA', phone: '57' },
  { code: 'CR', label: 'COSTA RICA', phone: '506' },
  { code: 'CU', label: 'CUBA', phone: '53' },
  { code: 'CV', label: 'CABO VERDE', phone: '238' },
  { code: 'CW', label: 'CURAZAO', phone: '599' },
  { code: 'CX', label: 'ISLA DE NAVIDAD', phone: '61' },
  { code: 'CY', label: 'CHIPRE', phone: '357' },
  { code: 'CZ', label: 'REPÚBLICA CHECA', phone: '420' },
  {
    code: 'DE',
    label: 'ALEMANIA',
    phone: '49',
    suggested: true,
  },
  { code: 'DJ', label: 'YIBUTI', phone: '253' },
  { code: 'DK', label: 'DINAMARCA', phone: '45' },
  { code: 'DM', label: 'DOMINICA', phone: '1-767' },
  {
    code: 'DO',
    label: 'REPÚBLICA DOMINICANA',
    phone: '1-809',
  },
  { code: 'DZ', label: 'ARGELIA', phone: '213' },
  { code: 'EC', label: 'ECUADOR', phone: '593' },
  { code: 'EE', label: 'ESTONIA', phone: '372' },
  { code: 'EG', label: 'EGIPTO', phone: '20' },
  { code: 'EH', label: 'SAHARA OCCIDENTAL', phone: '212' },
  { code: 'ER', label: 'ERITREA', phone: '291' },
  { code: 'ES', label: 'ESPAÑA', phone: '34' },
  { code: 'ET', label: 'ETIOPÍA', phone: '251' },
  { code: 'FI', label: 'FINLANDIA', phone: '358' },
  { code: 'FJ', label: 'FIYI', phone: '679' },
  {
    code: 'FK',
    label: 'ISLAS MALVINAS (FALKLAND ISLANDS)',
    phone: '500',
  },
  {
    code: 'FM',
    label: 'MICRONESIA, ESTADOS FEDERADOS DE',
    phone: '691',
  },
  { code: 'FO', label: 'ISLAS FEROE', phone: '298' },
  {
    code: 'FR',
    label: 'FRANCIA',
    phone: '33',
    suggested: true,
  },
  { code: 'GA', label: 'GABÓN', phone: '241' },
  { code: 'GB', label: 'REINO UNIDO', phone: '44' },
  { code: 'GD', label: 'GRANADA', phone: '1-473' },
  { code: 'GE', label: 'GEORGIA', phone: '995' },
  { code: 'GF', label: 'GUAYANA FRANCESA', phone: '594' },
  { code: 'GG', label: 'GUERNSEY', phone: '44' },
  { code: 'GH', label: 'GHANA', phone: '233' },
  { code: 'GI', label: 'GIBRALTAR', phone: '350' },
  { code: 'GL', label: 'GROENLANDIA', phone: '299' },
  { code: 'GM', label: 'GAMBIA', phone: '220' },
  { code: 'GN', label: 'GUINEA', phone: '224' },
  { code: 'GP', label: 'GUADALUPE', phone: '590' },
  { code: 'GQ', label: 'GUINEA ECUATORIAL', phone: '240' },
  { code: 'GR', label: 'GRECIA', phone: '30' },
  {
    code: 'GS',
    label: 'ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR',
    phone: '500',
  },
  { code: 'GT', label: 'GUATEMALA', phone: '502' },
  { code: 'GU', label: 'GUAM', phone: '1-671' },
  { code: 'GW', label: 'GUINEA-BISÁU', phone: '245' },
  { code: 'GY', label: 'GUYANA', phone: '592' },
  { code: 'HK', label: 'HONG KONG', phone: '852' },
  {
    code: 'HM',
    label: 'ISLAS HEARD Y MCDONALD',
    phone: '672',
  },
  { code: 'HN', label: 'HONDURAS', phone: '504' },
  { code: 'HR', label: 'CROACIA', phone: '385' },
  { code: 'HT', label: 'HAITÍ', phone: '509' },
  { code: 'HU', label: 'HUNGRÍA', phone: '36' },
  { code: 'ID', label: 'INDONESIA', phone: '62' },
  { code: 'IE', label: 'IRLANDA', phone: '353' },
  { code: 'IL', label: 'ISRAEL', phone: '972' },
  { code: 'IM', label: 'ISLA DE MAN', phone: '44' },
  { code: 'IN', label: 'INDIA', phone: '91' },
  {
    code: 'IO',
    label: 'TERRITORIO BRITÁNICO DEL OCÉANO ÍNDICO',
    phone: '246',
  },
  { code: 'IQ', label: 'IRAK', phone: '964' },
  {
    code: 'IR',
    label: 'IRÁN, REPÚBLICA ISLÁMICA DE',
    phone: '98',
  },
  { code: 'IS', label: 'ISLANDIA', phone: '354' },
  { code: 'IT', label: 'ITALIA', phone: '39' },
  { code: 'JE', label: 'JERSEY', phone: '44' },
  { code: 'JM', label: 'JAMAICA', phone: '1-876' },
  { code: 'JO', label: 'JORDANIA', phone: '962' },
  {
    code: 'JP',
    label: 'JAPÓN',
    phone: '81',
    suggested: true,
  },
  { code: 'KE', label: 'KENIA', phone: '254' },
  { code: 'KG', label: 'KIRGUISTÁN', phone: '996' },
  { code: 'KH', label: 'CAMBOYA', phone: '855' },
  { code: 'KI', label: 'KIRIBATI', phone: '686' },
  { code: 'KM', label: 'COMORAS', phone: '269' },
  {
    code: 'KN',
    label: 'SAN CRISTÓBAL Y NIEVES',
    phone: '1-869',
  },
  {
    code: 'KP',
    label: 'COREA, REPÚBLICA POPULAR DEMOCRÁTICA DE',
    phone: '850',
  },
  { code: 'KR', label: 'COREA, REPÚBLICA DE', phone: '82' },
  { code: 'KW', label: 'KUWAIT', phone: '965' },
  { code: 'KY', label: 'ISLAS CAIMÁN', phone: '1-345' },
  { code: 'KZ', label: 'KAZAJISTÁN', phone: '7' },
  {
    code: 'LA',
    label: 'REPÚBLICA DEMOCRÁTICA POPULAR LAO',
    phone: '856',
  },
  { code: 'LB', label: 'LÍBANO', phone: '961' },
  { code: 'LC', label: 'SANTA LUCÍA', phone: '1-758' },
  { code: 'LI', label: 'LIECHTENSTEIN', phone: '423' },
  { code: 'LK', label: 'SRI LANKA', phone: '94' },
  { code: 'LR', label: 'LIBERIA', phone: '231' },
  { code: 'LS', label: 'LESOTO', phone: '266' },
  { code: 'LT', label: 'LITUANIA', phone: '370' },
  { code: 'LU', label: 'LUXEMBURGO', phone: '352' },
  { code: 'LV', label: 'LETONIA', phone: '371' },
  { code: 'LY', label: 'LIBIA', phone: '218' },
  { code: 'MA', label: 'MARRUECOS', phone: '212' },
  { code: 'MC', label: 'MÓNACO', phone: '377' },
  {
    code: 'MD',
    label: 'MOLDAVIA, REPÚBLICA DE',
    phone: '373',
  },
  { code: 'ME', label: 'MONTENEGRO', phone: '382' },
  {
    code: 'MF',
    label: 'SAN MARTÍN (PARTE FRANCESA)',
    phone: '590',
  },
  { code: 'MG', label: 'MADAGASCAR', phone: '261' },
  { code: 'MH', label: 'ISLAS MARSHALL', phone: '692' },
  {
    code: 'MK',
    label: 'MACEDONIA, ANTIGUA REPÚBLICA YUGOSLAVA DE',
    phone: '389',
  },
  { code: 'ML', label: 'MALÍ', phone: '223' },
  { code: 'MM', label: 'MYANMAR', phone: '95' },
  { code: 'MN', label: 'MONGOLIA', phone: '976' },
  { code: 'MO', label: 'MACAO', phone: '853' },
  {
    code: 'MP',
    label: 'ISLAS MARIANAS DEL NORTE',
    phone: '1-670',
  },
  { code: 'MQ', label: 'MARTINICA', phone: '596' },
  { code: 'MR', label: 'MAURITANIA', phone: '222' },
  { code: 'MS', label: 'MONTSERRAT', phone: '1-664' },
  { code: 'MT', label: 'MALTA', phone: '356' },
  { code: 'MU', label: 'MAURICIO', phone: '230' },
  { code: 'MV', label: 'MALDIVAS', phone: '960' },
  { code: 'MW', label: 'MALAUI', phone: '265' },
  { code: 'MX', label: 'MÉXICO', phone: '52' },
  { code: 'MY', label: 'MALASIA', phone: '60' },
  { code: 'MZ', label: 'MOZAMBIQUE', phone: '258' },
  { code: 'NA', label: 'NAMIBIA', phone: '264' },
  { code: 'NC', label: 'NUEVA CALEDONIA', phone: '687' },
  { code: 'NE', label: 'NÍGER', phone: '227' },
  { code: 'NF', label: 'ISLA NORFOLK', phone: '672' },
  { code: 'NG', label: 'NIGERIA', phone: '234' },
  { code: 'NI', label: 'NICARAGUA', phone: '505' },
  { code: 'NL', label: 'PAÍSES BAJOS', phone: '31' },
  { code: 'NO', label: 'NORUEGA', phone: '47' },
  { code: 'NP', label: 'NEPAL', phone: '977' },
  { code: 'NR', label: 'NAURU', phone: '674' },
  { code: 'NU', label: 'NIUE', phone: '683' },
  { code: 'NZ', label: 'NUEVA ZELANDA', phone: '64' },
  { code: 'OM', label: 'OMÁN', phone: '968' },
  { code: 'PA', label: 'PANAMÁ', phone: '507' },
  { code: 'PE', label: 'PERÚ', phone: '51' },
  { code: 'PF', label: 'POLINESIA FRANCESA', phone: '689' },
  { code: 'PG', label: 'PAPÚA NUEVA GUINEA', phone: '675' },
  { code: 'PH', label: 'FILIPINAS', phone: '63' },
  { code: 'PK', label: 'PAKISTÁN', phone: '92' },
  { code: 'PL', label: 'POLONIA', phone: '48' },
  {
    code: 'PM',
    label: 'SAN PEDRO Y MIQUELÓN',
    phone: '508',
  },
  { code: 'PN', label: 'PITCAIRN', phone: '870' },
  { code: 'PR', label: 'PUERTO RICO', phone: '1' },
  {
    code: 'PS',
    label: 'PALESTINA, ESTADO DE',
    phone: '970',
  },
  { code: 'PT', label: 'PORTUGAL', phone: '351' },
  { code: 'PW', label: 'PALAOS', phone: '680' },
  { code: 'PY', label: 'PARAGUAY', phone: '595' },
  { code: 'QA', label: 'CATAR', phone: '974' },
  { code: 'RE', label: 'REUNIÓN', phone: '262' },
  { code: 'RO', label: 'RUMANIA', phone: '40' },
  { code: 'RS', label: 'SERBIA', phone: '381' },
  { code: 'RU', label: 'FEDERACIÓN RUSA', phone: '7' },
  { code: 'RW', label: 'RUANDA', phone: '250' },
  { code: 'SA', label: 'ARABIA SAUDITA', phone: '966' },
  { code: 'SB', label: 'ISLAS SALOMÓN', phone: '677' },
  { code: 'SC', label: 'SEYCHELLES', phone: '248' },
  { code: 'SD', label: 'SUDÁN', phone: '249' },
  { code: 'SE', label: 'SUECIA', phone: '46' },
  { code: 'SG', label: 'SINGAPUR', phone: '65' },
  { code: 'SH', label: 'SANTA ELENA', phone: '290' },
  { code: 'SI', label: 'ESLOVENIA', phone: '386' },
  {
    code: 'SJ',
    label: 'SVALBARD Y JAN MAYEN',
    phone: '47',
  },
  { code: 'SK', label: 'ESLOVAQUIA', phone: '421' },
  { code: 'SL', label: 'SIERRA LEONA', phone: '232' },
  { code: 'SM', label: 'SAN MARINO', phone: '378' },
  { code: 'SN', label: 'SENEGAL', phone: '221' },
  { code: 'SO', label: 'SOMALIA', phone: '252' },
  { code: 'SR', label: 'SURINAM', phone: '597' },
  { code: 'SS', label: 'SUDÁN DEL SUR', phone: '211' },
  {
    code: 'ST',
    label: 'SANTO TOMÉ Y PRÍNCIPE',
    phone: '239',
  },
  { code: 'SV', label: 'EL SALVADOR', phone: '503' },
  {
    code: 'SX',
    label: 'SINT MAARTEN (PARTE NEERLANDESA)',
    phone: '1-721',
  },
  {
    code: 'SY',
    label: 'REPÚBLICA ÁRABE SIRIA',
    phone: '963',
  },
  { code: 'SZ', label: 'ESUATINI', phone: '268' },
  {
    code: 'TC',
    label: 'ISLAS TURCAS Y CAICOS',
    phone: '1-649',
  },
  { code: 'TD', label: 'CHAD', phone: '235' },
  {
    code: 'TF',
    label: 'TIERRAS AUSTRALES FRANCESAS',
    phone: '262',
  },
  { code: 'TG', label: 'TOGO', phone: '228' },
  { code: 'TH', label: 'TAILANDIA', phone: '66' },
  { code: 'TJ', label: 'TAYIKISTÁN', phone: '992' },
  { code: 'TK', label: 'TOKELAU', phone: '690' },
  { code: 'TL', label: 'TIMOR ORIENTAL', phone: '670' },
  { code: 'TM', label: 'TURKMENISTÁN', phone: '993' },
  { code: 'TN', label: 'TÚNEZ', phone: '216' },
  { code: 'TO', label: 'TONGA', phone: '676' },
  { code: 'TR', label: 'TURQUÍA', phone: '90' },
  {
    code: 'TT',
    label: 'TRINIDAD Y TOBAGO',
    phone: '1-868',
  },
  { code: 'TV', label: 'TUVALU', phone: '688' },
  {
    code: 'TW',
    label: 'TAIWÁN, PROVINCIA DE CHINA',
    phone: '886',
  },
  {
    code: 'TZ',
    label: 'TANZANIA, REPÚBLICA UNIDA DE',
    phone: '255',
  },
  { code: 'UA', label: 'UCRANIA', phone: '380' },
  { code: 'UG', label: 'UGANDA', phone: '256' },
  {
    code: 'US',
    label: 'ESTADOS UNIDOS',
    phone: '1',
    suggested: true,
  },
  { code: 'UY', label: 'URUGUAY', phone: '598' },
  { code: 'UZ', label: 'UZBEKISTÁN', phone: '998' },
  {
    code: 'VA',
    label: 'SANTA SEDE (CIUDAD DEL VATICANO)',
    phone: '379',
  },
  {
    code: 'VC',
    label: 'SAN VICENTE Y LAS GRANADINAS',
    phone: '1-784',
  },
  { code: 'VE', label: 'VENEZUELA', phone: '58' },
  {
    code: 'VG',
    label: 'ISLAS VÍRGENES BRITÁNICAS',
    phone: '1-284',
  },
  {
    code: 'VI',
    label: 'ISLAS VÍRGENES DE LOS ESTADOS UNIDOS',
    phone: '1-340',
  },
  { code: 'VN', label: 'VIETNAM', phone: '84' },
  { code: 'VU', label: 'VANUATU', phone: '678' },
  { code: 'WF', label: 'WALLIS Y FUTUNA', phone: '681' },
  { code: 'WS', label: 'SAMOA', phone: '685' },
  { code: 'XK', label: 'KOSOVO', phone: '383' },
  { code: 'YE', label: 'YEMEN', phone: '967' },
  { code: 'YT', label: 'MAYOTTE', phone: '262' },
  { code: 'ZA', label: 'SUDÁFRICA', phone: '27' },
  { code: 'ZM', label: 'ZAMBIA', phone: '260' },
  { code: 'ZW', label: 'ZIMBABUE', phone: '263' },
];
